import { Switch, Route, useLocation } from "wouter";
import { useEffect } from "react";
import { queryClient } from "./lib/queryClient";
import { QueryClientProvider } from "@tanstack/react-query";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "@/components/ui/toaster";
import { TooltipProvider } from "@/components/ui/tooltip";
import { CartProvider } from "@/lib/cart";
import { ThemeProvider } from "@/lib/theme";
import { Header } from "@/components/header";
import { Footer } from "@/components/footer";
import Home from "@/pages/home";
import GroupPage from "@/pages/group";
import CategoryPage from "@/pages/category";
import ProductDetail from "@/pages/product-detail";
import CartPage from "@/pages/cart";
import CheckoutPage from "@/pages/checkout";
import CheckoutSuccess from "@/pages/checkout-success";
import OrderConfirmation from "@/pages/order-confirmation";
import PurchasesPage from "@/pages/purchases";
import MessagesPage from "@/pages/messages";
import SettingsPage from "@/pages/settings";
import AdminPage from "@/pages/admin";
import AuthPage from "@/pages/auth";
import ResetPasswordPage from "@/pages/reset-password";
import PricingPage from "@/pages/pricing";
import SubscriptionSuccessPage from "@/pages/subscription-success";
import FAQPage from "@/pages/faq";
import TermsPage from "@/pages/terms";
import ContactPage from "@/pages/contact";
import BlogPage from "@/pages/blog";
import AboutPage from "@/pages/about";
import TestimonialsPage from "@/pages/testimonials";
import TutorialsPage from "@/pages/tutorials";
import NotFound from "@/pages/not-found";

function ScrollToTop() {
  const [location] = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);
  return null;
}

function Router() {
  return (
    <Switch>
      <Route path="/" component={Home} />
      <Route path="/templates">{() => <GroupPage group="templates" />}</Route>
      <Route path="/indicators">{() => <GroupPage group="indicators" />}</Route>
      <Route path="/category/:slug" component={CategoryPage} />
      <Route path="/product/:slug" component={ProductDetail} />
      <Route path="/cart" component={CartPage} />
      <Route path="/checkout" component={CheckoutPage} />
      <Route path="/checkout/success" component={CheckoutSuccess} />
      <Route path="/order/:id" component={OrderConfirmation} />
      <Route path="/purchases" component={PurchasesPage} />
      <Route path="/messages" component={MessagesPage} />
      <Route path="/settings" component={SettingsPage} />
      <Route path="/admin" component={AdminPage} />
      <Route path="/auth" component={AuthPage} />
      <Route path="/faq" component={FAQPage} />
      <Route path="/terms" component={TermsPage} />
      <Route path="/contact" component={ContactPage} />
      <Route path="/blog" component={BlogPage} />
      <Route path="/about" component={AboutPage} />
      <Route path="/testimonials" component={TestimonialsPage} />
      <Route path="/tutorials" component={TutorialsPage} />
      <Route path="/pricing" component={PricingPage} />
      <Route path="/subscription/success" component={SubscriptionSuccessPage} />
      <Route path="/forgot-password" component={ResetPasswordPage} />
      <Route path="/reset-password" component={ResetPasswordPage} />
      <Route component={NotFound} />
    </Switch>
  );
}

function App() {
  return (
    <HelmetProvider>
    <QueryClientProvider client={queryClient}>
      <ThemeProvider>
        <CartProvider>
          <TooltipProvider>
            <div className="min-h-screen flex flex-col bg-background text-foreground">
              <Header />
              <ScrollToTop />
              <main className="flex-1">
                <Router />
              </main>
              <Footer />
            </div>
            <Toaster />
          </TooltipProvider>
        </CartProvider>
      </ThemeProvider>
    </QueryClientProvider>
    </HelmetProvider>
  );
}

export default App;
